export default __webpack_public_path__ + "fonts/house-solid.svg";